export function normalizeName(s) {
  return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
}

export function indexByName(regions) {
  const idx = {};
  (regions || []).forEach((r) => { idx[normalizeName(r.name)] = r; });
  return idx;
}

export const FALLBACK_FILL = '#e0e0e0';

export function styleForFeature(index) {
  return (feature) => {
    const props = (feature && feature.properties) || {};
    const region = index[normalizeName(props.nazwa || props.name)];
    return {
      fillColor: region ? region.color : FALLBACK_FILL,
      color: '#555',
      weight: 1,
      fillOpacity: 0.75,
    };
  };
}

export function tooltipLabel(region) {
  if (!region) return '';
  if (region.count == null) return `${region.name} — brak danych`;
  if (region.countMax != null) return `${region.name} — ${region.count}/${region.countMax}`;
  return `${region.name} — ${region.count}`;
}
